import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setTransferDomain', function setTransferDomain(
    transferState: boolean
) {
    store.legacyPremiumUserDomainState.isTransferredToGoDaddy = transferState;
});
